<template lang="html">
  <div>
    <div class="row margin-top-25">
      <div class="col-4">
        <h2 class="rect__subtitle">INTERACTIONS</h2>
        <div class="rect__stats">
          <h1>
            {{ currPeriod.interactions | addK }}
            <div :class="[currPeriod.interactions > prevPeriod.interactions ? 'up' : 'down']"></div>
          </h1>
          <p v-html="`${getPreviousPeriodName()}<br />${addK(prevPeriod.interactions)}`"></p>
        </div>
      </div>
      <div class="col-4">
        <h2 class="rect__subtitle">INTENTS RECOGNIZED</h2>
        <div class="rect__stats border-box">
          <h1>
            {{ currPeriod.questionsRecognized | round(currPeriod.questionsAsked) }}%
            <div :class="[currPeriod.questionsRecognized > prevPeriod.questionsRecognized ? 'up' : 'down']"></div>
          </h1>
          <p v-html="`${getPreviousPeriodName()}<br />${round(prevPeriod.questionsRecognized, prevPeriod.questionsAsked)}%`"></p>
        </div>
      </div>
      <div class="col-4">
        <h2 class="rect__subtitle">TOUCHLESS HANDLING</h2>
        <div class="rect__stats border-box">
          <h1>{{ currPeriod.touchlessHandling | fix }}%</h1>
          <p v-html="`${getPreviousPeriodName()}<br />${fix(prevPeriod.touchlessHandling, 1)}%`"></p>
        </div>
      </div>
    </div>

    <div class="chart-wrapper">
      <BarChart
        :options="getSelectedOptions()"
        :chart-data="isDaily ? convertDataToChart(this.fullDataDaily) : convertDataToChart(this.fullDataMonthly)" />
    </div>
  </div>
</template>

<script lang="ts">
import BarChart from './charts/Bar.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { addK, fix, round } from '../filters/number.filters'
import { months } from '@common/constants/time.constant'
import ItemToggle from '@/components/helpers/ItemToggle.vue'
import { getDaysDiff, getFullMonthName, isDateBetween } from '@common/helpers/date.helper'

@Component({
  methods: { addK, round, fix },
  components: { ItemToggle, BarChart },
  filters: {
    fix: fix,
    round: round,
    addK: addK
  }
})
export default class Interactions extends Vue {
  @Prop({ default: () => ([]) }) readonly currentPeriod: Date[]
  @Prop({ default: () => ({}) }) readonly currPeriod: any
  @Prop({ default: () => ({}) }) readonly prevPeriod: any
  @Prop({ default: () => [] }) readonly fullDataDaily: any[]
  @Prop({ default: () => ({}) }) readonly fullDataMonthly: any

  getSelectedOptions() {
    return {
      scales: {
        x: {
          color: 'red',
          ticks: {
            font: (context) => {
              const isInRange = context.tick.label.startsWith(' ');
              return { weight: isInRange ? 'bold' : 'normal', size: isInRange ? 11 : 11 };
            },
            color: (context) => {
              const isInRange = context.tick.label.startsWith(' ');
              return isInRange ? '#777' : '#666';
            }
          }
        }
      }
    }
  }

  get isDaily() {
    const [startDate, endDate] = this.currentPeriod
    return getDaysDiff(startDate, endDate) <= 31
  }

  getPreviousPeriodName() {
    const dayDiff = getDaysDiff(this.prevPeriod.startDate, this.currPeriod.startDate)
    switch (dayDiff) {
      case 1:
        return 'Yesterday'
      case 7:
        if (this.currPeriod.startDate.getDay() === 1) {
          return 'Last week'
        }
      case 30:
      case 31:
        if (this.currPeriod.startDate.getDate() === 1) {
          return 'Last month'
        }
    }
    return `${this.currentPeriodText(this.prevPeriod.startDate)} -<br>${this.currentPeriodText(this.prevPeriod.endDate)}`
  }

  currentPeriodText(date?: Date) {
    if (!date) return ''
    return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`
  }

  convertDataToChart(rawData) {
    const interactions = []
    const users = []
    const labels = []

    for (const item of rawData) {
      interactions.push(item.interactions)
      users.push(item.users)
      if (this.isDaily) {
        const value = item.label.split('-');
        labels.push(`${isDateBetween(item.date, this.currentPeriod[0], this.currentPeriod[1]) ? ' ' : ''}${value[0]} ${getFullMonthName(parseInt(value[1], 10) - 1)}`)
      } else {
        labels.push(`${this.currentPeriod[0].getMonth() <= item.month && this.currentPeriod[1].getMonth() >= item.month ? ' ' : ''}${item.label}`)
      }
    }

    return {
      labels,
      datasets: [
        { label: 'Interactions', data: interactions, backgroundColor: '#8743ff' },
        { label: 'Users', data: users, backgroundColor: '#fff' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'analytics.style';

.chart-wrapper {
  margin-top: 20px;
  width: 100%;
}

.rect__subtitle {
  color: white;
}
</style>
